<template>
  <div>
    <!-- top sales store -->
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'ChargeAccountStore',
  props:{
    // selectedTimePeriod:{default:'day'},
  },
  computed:{
    dataKey(){return 'companyNames'},
    keys(){return Object.keys(this[this.dataKey])},
    // apiRoutes(){return ['/Daily/RCGB/Charges']},
    // apiRoute(){return this.apiRoutes[0]},
    // dataArray(){return this[this.dataKey]},

  },
  data(){
    return {
      companyNames: {
        "0": "N/A",
        "1": "Evraz/Real",
        "2": "SRG",
        "3": "Other",
        "4": "Misc"
      },
      meta:{
      }
    }
  },
  mounted(){
    
    Vue.prototype.$chargeAccountCompanyNames = this.companyNames;
    console.log('DEBUG', 'Vue.prototype.$chargeAccountCompanyNames', this.$chargeAccountCompanyNames);
  },
  unmounted() {
    
  },
  watch: {
  },
  methods:{
    

    // Helpters
    
  },
}
</script>